import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useParams, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import Select from 'react-select'
import {Config} from '../../Config'
import moment from "moment-timezone";

export default function UserEdit() {
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let uId = decode.id;

    const roles = new Role();
    let userId = roles.loginUserId;

    let [passwordInputType, setPasswordInputType] = React.useState('password');
    let [confirmPasswordInputType, setConfirmPasswordInputType] = React.useState('password');

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [agency, setAgency] = React.useState('');
    let [permission, setPermission] = React.useState('');
    let [permissionId, setPermissionId] = React.useState(null);
    let [agencyId, setAgencyId] = React.useState(null);
    let [statusChecked, setStatusChecked] = React.useState(false);
    const navigate = useNavigate();

    let refEmail = React.useRef();
    let refPassword = React.useRef();
    let refConfirmPassword = React.useRef();
    let refContact = React.useRef();
    let refPhone = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resAgency = await Utils.getAgency();
                setAgency(resAgency);
                const resPerms = await getPermission();
                setPermission(resPerms);
                const resView = await getView();
                setData(resView);
                setAgencyId(resAgency.filter(e => e.id === resView.agencyId)[0]);
                setPermissionId(resView.permissionId);
                setStatusChecked(resView.status===1);
                refEmail.current.value = resView.email;
                refPhone.current.value = resView.phone;
                refContact.current.value = resView.contact;
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getPermission () {
        const response = await fetch(Config.url.API_URL +'/api/permission/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getView () {
        const response = await fetch(Config.url.API_URL +'/api/user/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: uId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onUpdate = () => {
        let email = refEmail.current.value;
        let password = refPassword.current.value;
        let confirmPassword = refConfirmPassword.current.value;
        let contact = refContact.current.value;
        let phone = refPhone.current.value;

        if(!email || !Utils.validateEmail.test(email)) {
            toast.error("กรุณาระบุ Email ให้ถูกต้อง\n* เช่น your@email.com");
            refEmail.current.focus();
        }
        else if(password && !Utils.strengthPassword.test(password)) {
            toast.error("รหัสผ่านต้องประกอบไปด้วย\n- ภาษาอังกฤษ\n- ตัวเล็ก/ตัวใหญ่\n- อย่างน้อย 6-20 ตัวอักษร");
            refPassword.current.focus();
        }
        else if(password && !confirmPassword) {
            toast.error("กรุณาระบุ ยืนยันรหัสผ่านใหม่");
            refConfirmPassword.current.focus();
        }
        else if(password && confirmPassword && password !== confirmPassword) {
            toast.error("รหัสผ่านไม่ตรงกัน");
            refConfirmPassword.current.focus();
        }
        else if(!contact) {
            toast.error("กรุณาระบุ ชื่อผู้ติดต่อ");
            refContact.current.focus();
        }
        else if(!phone) {
            toast.error("กรุณาระบุ เบอร์ติดต่อ");
            refPhone.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                id: data.id,
                                contact: contact,
                                phone: phone,
                                email: email,
                                password: password,
                                currentEmail: data.email,
                                agencyId: agencyId ? agencyId.id : null,
                                permissionId: permissionId,
                                status: statusChecked[0].checked ? 1:0,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };
                            fetch(Config.url.API_URL +'/api/user/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/user', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeAgency = (obj) => {
        setAgencyId(obj);
    };

    const onChangePermission = (Id) => {
        setPermissionId(Id);
    };

    let [validEmail, setValidEmail] = React.useState(true);
    const onKeyUpEmail = (e) => {
        if(e.target.value) {
            let valid = Utils.validateEmail.test(e.target.value);
            setValidEmail(valid);
        }
        else {
            setValidEmail(true);
        }
        data.email = e.target.value;
    };
    let [validPassword, setValidPassword] = React.useState(true);
    const onKeyUpPassword = (e) => {
        if(e.target.value) {
            let valid = Utils.strengthPassword.test(e.target.value);
            setValidPassword(valid);
        }
        else {
            setValidPassword(true);
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> User</div>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="email" ref={refEmail} maxLength={100} onKeyUp={e => onKeyUpEmail(e)} disabled={data.email === 'admin@socialtag.com'} />
                                <p className={!validEmail ? 'text-danger mb-0 small':'d-none'}>รูปแบบอีเมลไม่ถูกต้อง</p>
                            </div>
                            <div className="col-12">
                                <label htmlFor="password" className="form-label">รหัสผ่าน</label>
                                <div className="position-relative">
                                    <input type={passwordInputType} className="form-control" id="password" ref={refPassword} maxLength={20} onKeyUp={e => onKeyUpPassword(e)} />
                                    <div className="eye-password" onClick={e => {setPasswordInputType(passwordInputType === 'password' ? 'text':'password')}}>
                                        {passwordInputType === 'text' ? <Icon.Eye /> : <Icon.EyeSlash />}
                                    </div>
                                </div>

                                <p className={!validPassword ? 'text-danger mb-0 small':'d-none'}>รูปแบบรหัสผ่านไม่ถูกต้อง</p>
                                <p className="mb-0 mt-2 small text-muted">* ต้องประกอบไปด้วย<br />- ภาษาอังกฤษ<br />- ตัวเล็ก/ตัวใหญ่<br />- อย่างน้อย 6-20 ตัวอักษร</p>
                            </div>
                            <div className="col-12">
                                <label htmlFor="confirmPassword" className="form-label">ยืนยันรหัสผ่าน</label>
                                <div className="position-relative">
                                    <input type={confirmPasswordInputType} className="form-control" id="confirmPassword" ref={refConfirmPassword} maxLength={20} />
                                    <div className="eye-password" onClick={e => {setConfirmPasswordInputType(confirmPasswordInputType === 'password' ? 'text':'password')}}>
                                        {confirmPasswordInputType === 'text' ? <Icon.Eye /> : <Icon.EyeSlash />}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <label htmlFor="agencyId" className="form-label">Agency</label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={agency}
                                    onChange={(event) => onChangeAgency(event)}
                                    value={agencyId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อผู้ติดต่อ <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refContact} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="phone" className="form-label">เบอร์ติดต่อ <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="phone" ref={refPhone} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="permissionId" className="form-label">Permission</label>
                                <select className="form-select" id="permissionId" onChange={(event) => onChangePermission(event.target.value)} value={permissionId ? permissionId:0}>
                                    <option value="">-- เลือก --</option>
                                {
                                    permission.length <= 0 ? '' :
                                        permission.map((row, index) => {
                                                return (
                                                    <option key={index} value={row.id}>{row.name}</option>);
                                        })
                                }
                                </select>
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/user'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 